import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=45c6039b&scoped=true&"
import script from "./mainBody.vue?vue&type=script&lang=js&"
export * from "./mainBody.vue?vue&type=script&lang=js&"
import style0 from "./mainBody.vue?vue&type=style&index=0&id=45c6039b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6039b",
  null
  
)

export default component.exports